import type { FC } from "react";

import type { SelectedBundleOptionValue } from "@jti/magento";

import SummaryBundleOptionValue from "./SummaryBundleOptionValue";

export type BundleOptionProps = {
  categoryName: string;
  values: SelectedBundleOptionValue[];
};

const SummaryBundleOption: FC<BundleOptionProps> = ({ categoryName, values }) => (
  <>
    {values.map((option) => {
      const { initial_price, presentation_price, product } = option?.presentation_info || {};
      let product_name = "label" in option ? option.label : option.product_name;

      if (values.length > 1) {
        product_name = `${categoryName}: ${product_name}`;
      }

      return (
        <SummaryBundleOptionValue
          key={`${categoryName} - ${option.id}`}
          prices={{ initial_price, presentation_price }}
          quantity={option.quantity}
          imageUrl={product?.small_image?.url}
          product_name={product_name}
          tooltip_info={option?.presentation_info.product.tooltip_info}
        />
      );
    })}
  </>
);

export default SummaryBundleOption;
